import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { getMainIconProps as o } from "./index.es2361.js";
const a = (n) => {
  const { outline: i, fill: t, size: l, innerElementFill: p } = o(n);
  return /* @__PURE__ */ d(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ d("g", { clipPath: "url(#clip0_260_3602)", children: [
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M14 17.375C15.104 17.375 16 16.479 16 15.375V4.375H2V15.375C2 16.479 2.896 17.375 4 17.375H14Z",
              fill: t
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M1.625 4H16.375V15.375C16.375 16.6861 15.3111 17.75 14 17.75H4C2.68889 17.75 1.625 16.6861 1.625 15.375V4ZM2.375 4.75V15.375C2.375 16.2719 3.10311 17 4 17H14C14.8969 17 15.625 16.2719 15.625 15.375V4.75H2.375Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.625 15.875V6.875H9.375V15.875H8.625Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M6.375 9.875V15.875H5.625V9.875H6.375Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.375 9.875V15.875H11.625V9.875H12.375Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M0.5 4H17.5V4.75H0.5V4Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M0.5 2H17.5V2.75H0.5V2Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M5.625 0.375C5.625 0.167893 5.79289 0 6 0H12C12.2071 0 12.375 0.167893 12.375 0.375V2.375C12.375 2.58211 12.2071 2.75 12 2.75H6C5.79289 2.75 5.625 2.58211 5.625 2.375V0.375ZM6.375 0.75V2H11.625V0.75H6.375Z",
              fill: i
            }
          )
        ] }),
        /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_260_3602", children: /* @__PURE__ */ e(
          "rect",
          {
            shapeRendering: "optimizeQuality",
            width: "18",
            height: "18",
            fill: p
          }
        ) }) })
      ]
    }
  );
};
a.__tags = [];
export {
  a as TrashIcon
};
//# sourceMappingURL=index.es352.js.map
